import { Constants } from "config/constants";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import Invites from "components/lib/Shared/CompanyDashboard/Invites";
import AccountSettings from "components/lib/Shared/CompanyDashboard/AccessTab";
import AssignPermission from "./AssignPermission";
import { classNames } from "utils";
import Tabs from "components/lib/Shared/Tabs";
import { Roles_Permissions_Constants } from "config/roles-permissions";

const initialTabs = [{ id: "access", label: "Access" }];

const DashboardAccessRequests = () => {
  const [generalTabs, setGeneralTabs] = useState(initialTabs);
  const [selectedTab, setSelectedTab] = useState(initialTabs[0]);

  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  const { company, dashboardRoles, dashboardPermissions } = useSelector(
    (state) => state.companyDashboardSlice
  );

  useEffect(() => {
    const isNotVOR = dashboardRoles?.some(
      (role) => role.name !== Roles_Permissions_Constants.DASHBOARD_ROLES.VOR
    );
    if (!isNotVOR) {
      setGeneralTabs([{ id: "access", label: "Access" }]);
    }
    if (
      dashboardRoles?.some(
        (role) => role.name === Roles_Permissions_Constants.DASHBOARD_ROLES.REGISTRAR
      ) || dashboardPermissions?.some(permission => permission.name === Roles_Permissions_Constants.DASHBOARD_PERMISSIONS.MANAGE_USERS)
    ) {
      setGeneralTabs([
        { id: "invites", label: "Invites" },
        { id: "access", label: "Access" },
        { id: "assign", label: "Assign" },
      ]);
    }
  }, [dashboardRoles]);

  const handleTabClick = (item) => {
    if (item?.disabled) return null;
    else setSelectedTab(item);
  };

  useEffect(() => {
    const tempSelectedTab = generalTabs[selectedTabIndex];
    if (tempSelectedTab) setSelectedTab(tempSelectedTab);
  }, [generalTabs, selectedTabIndex]);

  return (
    <div className="grid gap-4 mx-auto">
      <h4 className="text-sflPrimary text-xl font-medium">Account Settings</h4>
      <Tabs
        tabs={generalTabs}
        selectedTabIndex={selectedTabIndex}
        setSelectedTabIndex={setSelectedTabIndex}
        showTooltip
      />
      <div className="grid grid-cols-12">
        <div className="col-span-12 md:col-span-11 pt-2">
          {selectedTab.id === "invites" && <Invites />}
          {selectedTab.id === "access" && (
            <AccountSettings
              page="COMPANY_DASHBOARD"
              company={company}
              dashboardRoles={dashboardRoles}
            />
          )}
          {selectedTab.id === "assign" && <AssignPermission />}
        </div>
      </div>
    </div>
  );
};

export default DashboardAccessRequests;
